import { get } from 'lodash';
import React, { FC } from 'react';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryProjektTitel,
	SummaryTitel,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import SummaryLine from '../../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import AbschlussSeiteBox, { GefoerderteSummeProgrammInfo } from '../../../../antrag-components/AbschlussSeiteBox';

// import schemas
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const AbschlussMessefoerderung: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<SummaryTitel />
			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryLine
					label='Messename:'
					value={get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messename.path)}
				/>

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />

				<GefoerderteSummeProgrammInfo application={application} />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussMessefoerderung;
